class FileService {
  static async downloadBlob(blob: Blob, fileName: string, parent?: HTMLElement | null) {
    if (!blob) return;

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';

    link.setAttribute('download', fileName);
    parent ? parent.appendChild(link) : document.body.appendChild(link);

    link.click();

    URL.revokeObjectURL(url);
    link.parentNode && link.parentNode.removeChild(link);
  }
}

export default FileService;
